<template>
  <el-checkbox v-model="value" @update:modelValue="input">
    Block nonunique traffic
    <IconWithHint>
      Remove this ad from rotation<br />
      for a single visitor if the visitor<br />
      has already seen the ad.
    </IconWithHint>
  </el-checkbox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'BlockNonUnique',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const input = (newValue: boolean) => {
      context.emit('update:modelValue', newValue)
    }

    return { input, value }
  }
})
</script>
